export const snakeCase = (value: string) => value.replace(/([A-Z])/g, '_$1').replace(/^_/, '');
